import styled from "@emotion/styled"

const HeaderSeparator = styled.div`
  width: 1px;
  height: 100dvh;
  max-height: 360px;
  background: #e4e4e4;
  display: block;

  ${({ theme }) => theme.breakpoints.down("md")} {
    display: none;
  }

  ${({ theme }) => theme.breakpoints.between("md", "xl")} {
    display: none;
  }
`

export default HeaderSeparator
